import styled from "styled-components"
import { MojeHeader } from "../../components/header/MojeHeader"
import { MojeFooter } from "../../components/MojeFooter"

const BlogPageStyled = styled.div`
  background-color: white;
  margin-bottom: 20px;

  p {
    margin-top: 2rem;
    margin-bottom: 2rem;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-weight: 800;
    font-size: 1.2em;
    margin: 0;
  }

  ul,
  ol {
    list-style-position: inside;
  }

  ul {
    list-style-type: disc;
  }

  ol {
    list-style-type: decimal;
  }

  .blogTitle {
    font-size: 40px;
    font-weight: 900;
    line-height: 1.2;
  }
  .blogSubtitle {
    font-size: 20px;
    font-weight: 600;
  }
  .img {
    width: 100%;
    height: 400px;
    img {
      height: 100%;
      width: 100%;
      object-fit: cover;
    }
  }
  .date {
    color: #aaa;
    fontweight: 600;
  }
  .blogContent {
    width: 800px;
    margin: auto;
    margin-top: 20px;
    font-size: 16px;
    line-height: 2;
  }

  @media (max-width: 600px) {
    .img {
      width: 100%;
      height: 40vh;
    }
    .blogTitle {
      font-size: 30px;
    }
    .blogContent {
      width: 100%;
      padding: 0 20px;
      font-size: 14px;
    }
  }
`

export const BlogPage = (props) => {
  return (
    <>
      <MojeHeader venueMode showSearch scrollable />
      <BlogPageStyled>{props.children}</BlogPageStyled>
      <MojeFooter />
    </>
  )
}
